import { isValidCpr, Region } from '@monthio/react-components'
import { ValidateCprFunction, ValidateCprAgainstServerFunction } from '../types'
import i18n from 'i18next'
import { getNationalIdentificationNumberErrorTranslation } from '../utils/getNationalIdentificationNumberErrorTranslation'

const validateIdentityNumber: ValidateCprFunction = async (
	cprNumber,
	validateCprAgainstServer: ValidateCprAgainstServerFunction,
) => {
	const nationalId = cprNumber
	if (!nationalId) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}

	const validatedNationalId = isValidCpr(nationalId, { region: Region.Netherlands })

	if (!validatedNationalId.valid) {
		return {
			success: false,
			output: i18n.t(
				'nl-consumerInputs-personalInformation-identityNumberInvalid-text',
			),
		}
	}

	const cprServerResponse = await validateCprAgainstServer(nationalId)

	if (!cprServerResponse.isValid) {
		return {
			success: false,
			output: getNationalIdentificationNumberErrorTranslation(
				cprServerResponse.error?.message,
			),
		}
	}

	return {
		success: true,
		output: nationalId,
	}
}

export default validateIdentityNumber
